module.exports = __webpack_public_path__ + "media/the_sixth_amulet.db63ac5a.mp3";